module.exports = __webpack_public_path__ + "static/img/hong.8a974e82.png";